<template>
    <div class="form-check contact-list-label" @click.prevent="click">
        <input
                class="form-check-input"
                type="checkbox"
                name="contact-lists"
                :id="getId"
                :value="id"
                @click="click"
                v-model="checked"
        >
        <label class="form-check-label d-block" :for="getId">
            {{name}}
        </label>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import * as types from '../store/types.js'

    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            id: {
                type: Number,
                required: true
            }
        },
        data: () => {
            return {
                checked: false,
                watcher: null
            }
        },
        created(){
            this.checked = this.hasList(this.id)
            this.watcher = this.$watch('isOn', (newVal, oldVal) => {
                this.checked = newVal
            })
        },
        destroyed(){
            this.watcher && this.watcher()
        },
        computed: {
            ...mapGetters('search', ['hasList']),

            getId: function(){
                return 'cl-'+this.id;
            },
            isOn: function(){
                return this.hasList(this.id)
            }
        },
        methods: {
            ...mapActions('search', [types.SEARCH_TOGGLE_LIST]),
            click: function(event) {
                this[types.SEARCH_TOGGLE_LIST]({
                    id: this.id,
                    checked: !this.checked
                }).then(isChecked => {
                    this.checked = isChecked
                    this.$emit('click')
                    console.log('search lists updated')
                })
            }
        }
    }
</script>
<style scoped>
.contact-list-label:hover {
    background-color: #f0f0f0;
}
</style>